import {
    actionsEditMode as actions
} from "./types";

export const setIsEditMode = (newState: boolean) => {
    return {
        type: actions.SET_IS_EDIT_MODE,
        payload: newState,
    };
};